export const BUTTON = {
  Start: 'start-check',
  Cancel: 'annuleren',
  Previous: 'previous-step',
  Next: 'next-step',
  Contact: 'contact',
  Scan: 'scan-qr',
  Edit: 'edit',
  Download: 'download',
  Social: 'social',
  Result: 'show-result',
  Appointment: 'appointment',
  Information: 'more-information',
  RequestProduct: 'request-product',
} as const;
